/* prettier-ignore */
export default ({
  getIsDialogOpen: state => state.permissionDialog.dialogOpen
});
